import { Box, Grid, Link, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import ScrollTop from "./ScrollTop";

function TermsOfServices({ classes }) {
  return (
    <>
      <Grid
        container
        style={{
          minHeight: "100vh",
          width: "100%",
          padding: "15px 40px",
          margin: "0 auto",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            textAlign: "justify",
          }}
        >
          <Box mt={4} mb={2}>
            <Typography
              variant="h5"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Terms of Use
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            Please read these terms of use carefully by accessing or using this
            internet-based platform, you agree to be bound by the terms
            described herein and all terms incorporated by reference. If you do
            not agree to all of these terms, do not use this internet-based
            platform.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Basic Definition:
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            This “Terms of Service Agreement” (“Agreement”) sets forth the
            legally binding terms for your use of the NecessaryDevil Services.
            You are only authorized to use the NecessaryDevil Services
            (regardless of whether your access or use is intended or not) if you
            agree to abide by all applicable laws and to this Agreement. By
            registering on, accessing, browsing, downloading or using the
            NecessaryDevil site for any general purpose or for the specific
            purpose of availing any service, you agree, automatically and
            immediately to be bound by this Agreement as well as by any the
            service specific terms and conditions applicable to each service,
            whether you are a “Visitor” (which means that you simply browse the
            NecessaryDevil site) or you are a “Member” (which means that you
            have registered with NecessaryDevil). The term “User” refers to a
            Visitor or a Member. Subject to your compliance with this Agreement,
            you may print these terms of use or save a copy of these terms of
            service for your own personal and non-commercial use If you wish to
            become a Member, communicate with other Members and make use of the
            NecessaryDevil Services, you must read this Agreement and indicate
            your acceptance during the Registration process. All the rights,
            benefits, liabilities and obligations under this Agreement shall, as
            the case may be, accrue to the benefit of, or incurred by,
            NecessaryDevil, regarding your use of the services.
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            The terms ‘service’ or ‘services’ would mean to include the
            interactive online solutions & information services offered by
            NecessaryDevil on the internet/mobile through which the user may
            access information carried by NecessaryDevil in the database
            maintained by it.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            You agree not to copy, sell, resell, duplicate any part of
            NecessaryDevil’s services & solutions for commercial purpose.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            These Terms of Service sets out the legally binding terms of your
            use of NecessaryDevil and your membership in NecessaryDevil and may
            be modified by NecessaryDevil at any time and without prior notice,
            such modifications to be effective upon posting by NecessaryDevil on
            the website. Your continued access or use of the Site and/or the
            Services after the Terms of Services have been revised constitutes
            your express consent to the modified Terms of Services. In the event
            of any inconsistency between our Privacy Policy and these Terms of
            Service, the Terms of Service shall prevail. If you do not agree to
            be bound by the terms of this Agreement, you may not use nor access
            our services.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Eligibility
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil services are available to all individuals who are at
            least 18 years of age. Individuals under the age of 18 may access
            and use the site, they shall do so only with the involvement and
            guidance of their parents and or legal guardians. In all such
            instances, their parents and or legal guardians will be held
            responsible for all the terms of this agreement. By registering with
            NecessaryDevil you consent to the use of:
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            (i) electronic means to complete the Terms and to provide you with
            any notices given pursuant to the Terms.
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            (ii) Electronic records to store information related to the Terms or
            your use of the Services.
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil has the right, in its sole discretion, to suspend or
            terminate your use of NecessaryDevil services and refuse any and all
            current or future use of all or any portion of NecessaryDevil’s
            services.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Health, Fitness, Demographic and Location Data Consent
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            By using the NecessaryDevil application and participating in running
            or endurance events through the platform, you may voluntarily
            provide permission for the Application to collect and process
            certain health, fitness, demographic, and location-related
            information necessary for the operation of the services.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Such data will only be collected with your explicit consent and only
            for the purposes described below.
          </Typography>

          <Box mt={2} mb={1}>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Health &amp; Fitness Data
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            With your permission, the Application may collect and process
            certain activity-related information during participation in events,
            including but not limited to:
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            • Daily step count
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Activity duration
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Distance covered during running or endurance activities
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            This information is used to measure performance, track activity
            completion, and validate participation in events hosted through the
            NecessaryDevil platform.
          </Typography>

          <Box mt={2} mb={1}>
            <Typography
              gutterBottom
              variant="subtitle1"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Demographic Data
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            In order to provide appropriate event categorization and fair
            competition rankings, the Application may collect certain
            demographic or physical information including:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Gender
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Height
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Weight
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Age group or other basic physical traits relevant to fitness
              activities
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            This information may be used to categorize participants, generate
            performance comparisons, and improve event management.
          </Typography>

          <Box mt={2} mb={1}>
            <Typography
              gutterBottom
              variant="subtitle1"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Location (GPS) Data
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            With your consent, the Application may access and process location
            information including:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Real-time or periodic GPS location during active event tracking
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Running routes or activity paths mapped using location
              coordinates
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Location data is used solely for tracking event participation,
            mapping routes, validating distance covered, and displaying activity
            maps and performance results within the application.
          </Typography>

          <Box mt={2} mb={1}>
            <Typography
              gutterBottom
              variant="subtitle1"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Purpose of Health and Location Data Collection
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The health, demographic, and location information collected through
            the Application is used exclusively for the following purposes:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Tracking running routes and distance accurately
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Measuring activity performance and validating participation in
            endurance events
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Displaying activity maps, progress reports, and results within the
            Application
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Enabling event verification, rankings, and leaderboards
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Ensuring fair participation and competition within events
            </Typography>
          </Box>

          <Box mt={2} mb={1}>
            <Typography
              gutterBottom
              variant="subtitle1"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Important Disclosures
            </Typography>
          </Box>

          <Typography variant="body2" className={classes.greyText}>
            • GPS and location data is collected only during active event
            tracking sessions.
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Location tracking automatically stops when the activity ends or
            when permission is revoked.
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Health and location data is not used for advertising purposes.
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Health and location data is not sold or shared for marketing
            purposes.
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Such data is used solely for core platform functionality and
              event management operations.
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Users may grant or revoke access to health or location permissions
            at any time through their device settings. Revoking such permissions
            may limit certain functionality of the Application.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Data Retention and Data Erasure
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil retains personal data only for as long as necessary
            to provide services and fulfill the purposes described in this
            Agreement and associated policies.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Personal data may be retained:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • For as long as your account remains active
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • As required to provide services and event participation
            functionality
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • As required under applicable laws and regulatory requirements
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Backup copies of certain data may temporarily persist for security,
            auditing, or legal compliance purposes.
          </Typography>
          <Box mt={2} mb={1}>
            <Typography
              gutterBottom
              variant="subtitle1"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Data Erasure
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Users have the right to request deletion of their personal data.
            Upon receiving a valid request, NecessaryDevil will delete or
            anonymize personal information from active systems unless retention
            is required for legal, regulatory, or security obligations.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Users may request deletion by:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Deleting their account through the Application (if available), or
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Contacting NecessaryDevil support at:{" "}
              <Link
                href="mailto:necessarydevil@interfaceinfosoft.com"
                underline="hover"
              >
                necessarydevil@interfaceinfosoft.com
              </Link>
            </Typography>
          </Box>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              User Rights and Choices
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Subject to applicable law, users may exercise the following rights
            regarding their personal data:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Access their personal information
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Correct or update inaccurate information
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • Request deletion of their account and associated personal data
          </Typography>
          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Withdraw consent for optional data collection, including health
              or location data
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Requests may be submitted through:
          </Typography>
          <Typography variant="body2" className={classes.greyText}>
            • In-application account settings, or
          </Typography>

          <Box mb={1}>
            <Typography variant="body2" className={classes.greyText}>
              • Email:{" "}
              <Link
                href="mailto:necessarydevil@interfaceinfosoft.com"
                underline="hover"
              >
                necessarydevil@interfaceinfosoft.com
              </Link>
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Withdrawal of consent may affect the availability or functionality
            of certain services that rely on such data.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Service
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil provides self-managed event organizing solutions to
            event organizers. Event organizers setup their event, fill up the
            details about their event such as event pricing, location, ticket
            inventory, attendee registration information collection and other
            such features. As used herein, “Customers” means NecessaryDevil
            event organizers (“Event Organizer “), registered event attendees
            (“Attendee “) and participants in our various affiliate programs.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Event Organizer Terms
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil offers organizers a web-based solution to organize
            endurance events (Running & Cycling), to sell tickets and provide
            online Attendee Registration solutions via the
            NecessaryDevil-Websites for events of the organizer to customers by
            using NecessaryDevil to take on the payment process. The details of
            NecessaryDevil services to the organizers are (each is a
            “NecessaryDevil-Service”):
          </Typography>

          <ol style={{ paddingLeft: 24 }}>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                A web-based software on the NecessaryDevil-websites to organize
                events and to sell tickets of the organizer for these events to
                ticket buyers. The organizer has the possibility to create an
                own website for their event (“event site”) and to offer a ticket
                sale. The ticket buyer can choose and buy the tickets on the
                event site directly.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Only the user and the organizer of an event are entering into an
                agreement regarding the event and the disposal of tickets for
                that event. NecessaryDevil only acts as a sales agent for the
                organizer of an event by order and for the account of this
                organizer. It is the organizers’ duty to advise and instruct the
                ticket buyers of their eventually existing right of objection
                according to the legal guidelines.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                The organizer authorizes NecessaryDevil hereby for the duration
                of this agreement to act as an agent by order and for the
                account of the organizer, to sell tickets to the public for
                events, offered by the organizer on the NecessaryDevil-Website,
                to undertake the payment process with the ticket buyers and/or
                their banks and to ship the tickets to the ticket buyers. This
                authorization also contains the right of NecessaryDevil to send
                payment reminders to the buyers.
              </Typography>
            </li>
          </ol>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Event Participant’s Terms
            </Typography>
          </Box>

          <ol style={{ paddingLeft: 24 }}>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Participants understand the inherent risks involved in the event
                and those related to participation therein. Participants accept
                the risk & confirm that she/he is participating at her/his sole
                & absolute risk.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Participants agree to follow the rules governed by the law of
                the land & make sure to keep their face masks handy all the time
                & maintain social distance while running or walking if required
                by the law.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Participant understands that she/he may be photographed or
                filmed before, during or after the event. The event organizers,
                sponsors, their principals, representatives, agents & assigns
                may utilize her/his image or her/ his likeness or his name for
                any legitimate purpose in connection with this event or future
                events to be organized by the event organizer.
              </Typography>
            </li>
            <li>
              <Typography variant="body2" className={classes.greyText}>
                Participant undertakes to follow all the rules of the event &
                also the directions & instructions given to her/him by the
                organizers of the event, their principals, representatives,
                agents and assigns.
              </Typography>
            </li>
          </ol>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Shipment & Delivery
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The shipment & the delivery of the tickets shall be by electronic
            means. No physical delivery of tickets shall take place.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Payment & Fees
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The NecessaryDevil payment model has two versions, one is
            transactions-based model & the other which charges lumpsum fees for
            an event. NecessaryDevil will be responsible only for the taxes
            applicable on NecessaryDevil Fees (including ND fee, PG fee and
            fixed ticket charge). Organizer will bear the full responsibility of
            the taxes applicable on ticket price and NecessaryDevil cannot be
            held accountable for any inaccurate information provided by
            organizer for such taxes.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Transaction Model
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer has to determine the base price for his tickets. This
            base price belongs to the organizer.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil charges a fee for every ticket sold via the
            Necessary-Websites (ND platform fees).
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            In the event that tickets for an event have been sold via the
            NecessaryDevil-Websites, and the event is cancelled for any reason
            not directly attributable to NecessaryDevil, then NecessaryDevil
            shall continue to be entitled to the ND platform fees and ticketing.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Accounting
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer has options of various payment method(s) (credit card,
            direct debiting, prepayment, invoice) to be offered to possible
            ticket buyers. In accordance to this choice NecessaryDevil
            undertakes accounting for the organizer and holds the money on a
            separate bank account. The organizer authorizes NecessaryDevil to do
            so. NecessaryDevil transfers the money received according to service
            pricing minus the fees payable to NecessaryDevil within 7 business
            days post the event to the organizer. The money has to be
            transferred to a bank account located in the country where the event
            took place and issued on the name of the organizer. For recurring
            events, NecessaryDevil reserves the right to pay out money before
            the event. NecessaryDevil reserves the right to change the number of
            days to transfer money to the event organizer at any time without
            notice. The organizer is aware of the risk that specific payment
            methods (direct debiting or credit card) can be reversed by the
            ticket buyers. The organizer bears this risk alone. If transactions
            are reversed after the payment to the organizer, these costs plus a
            fee for the reversed transaction at actuals are charged to the
            organizer.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer is obliged to raise objections, if any, against the
            accounts of NecessaryDevil within four weeks after issue of the
            account. If not the account is considered as being approved &
            closed.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Prevention against “Fraud & Misuse”
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The NecessaryDevil offer an extensive security system, in particular
            to protect organizers against reimbursement of credit card payments.
            Because of this security system it is possible that in exceptional
            cases some credit card providers may not be accepted.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            If the organizer arouses suspicion of misusage of the
            NecessaryDevil-Websites, NecessaryDevil has the right to deactivate
            the ticket shop of the organizer and to stop the ticket selling. In
            particular a suspicion of misusage of the NecessaryDevil-Websites is
            on hand, if it comes to attention before the event that the event
            shall not (or not in the way as stated in the ticket shop) take
            place. NecessaryDevil does not allow illegal or immoral events to
            take place on its platform.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            If the organizer arouses suspicion of misusage of the
            NecessaryDevil-Websites, NecessaryDevil has the right to delay the
            payout to the organizer even after 7 business days for further 60
            days. Within these 60 days NecessaryDevil will check if an improper
            use of the NecessaryDevil-Websites and / or NecessaryDevil-Services
            occurred. NecessaryDevil also reserves the right to block any event
            from its platform, if the event is found to be misleading to
            NecessaryDevil users. (For example: if an event is listed as free
            and an organizer forces its attendees to pay for the event
            separately, the listed event is deemed to be misleading to the event
            attendees.)
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            To verify your identity, we may ask for a valid ID proof like
            Passport and/Aadhar card, and for Companies Trade license and/or TRN
            certificate. We may require you to upload a copy of your valid ID
            proof, it will help us in identifying you to a high degree of
            fidelity as the inability to accurately identify individual may pose
            risks with respect to fraudulent claims, tax compliance, and
            creation or listing of valid events.
          </Typography>

          <Box>
            <Box mt={4} mb={2}>
              <Typography
                variant="h6"
                gutterBottom
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                Warranty of the Organizer
              </Typography>
            </Box>
            <Typography variant="body2" paragraph className={classes.greyText}>
              The warrants to NecessaryDevil that
            </Typography>

            <Typography variant="body2" paragraph className={classes.greyText}>
              A. The organizer is allowed to enter into this agreement with
              NecessaryDevil, including the right to authorize NecessaryDevil in
              accordance to these terms to act as an agent and to sell tickets
              for events of the organizer.
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              B. The organizer takes responsibility that he has all the
              necessary approvals for organizing the event and that nothing
              prohibits organizer from doing the event. If any situation
              changes, he will inform NecessaryDevil immediately. The organizer
              will hold NecessaryDevil indemnified for any losses arising out
              from his failure to take necessary approvals for organizing the
              event.
            </Typography>
          </Box>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Duties of the organizer
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer has the duty to inform NecessaryDevil immediately
            about unavailability or malfunctions of the NecessaryDevil-Website.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer has the obligation to inform NecessaryDevil
            immediately about every change of his name, company name, address,
            legal form or bank details in written form or via E-Mail. The
            organizer shall not use the NecessaryDevil-Services for illegal or
            immoral events such as political or religious extremism,
            pornographic, or violent events.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The organizer shall not use the NecessaryDevil-Services to upload,
            post, email, transmit or otherwise make available any information
            that is unlawful, harmful, threatening, abusive, harassing,
            tortuous, defamatory, vulgar, obscene, libelous, invasive of
            another’s privacy, hateful, or racially, ethnically or otherwise
            objectionable; The organizer shall not impersonate any person or
            entity, including, but not limited to, an NecessaryDevil
            representative, forum leader, or falsely state or otherwise
            misrepresent its affiliation with a person or entity; The organizer
            shall not forge headers or otherwise manipulate identifiers in order
            to disguise the origin of any Information transmitted through the
            service.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Right to terminate
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            You agree that NecessaryDevil, in its sole discretion, for any or no
            reason, and without penalty, may terminate this agreement.
            NecessaryDevil may also in its sole discretion and at any time
            discontinue providing access to the services, or any part thereof,
            with or without notice, if the organizer has contravened against
            important provisions of these terms; or the organizer has filed for
            bankruptcy, insolvency proceedings have been started or the start of
            the insolvency proceedings has been dismissed in default of assets;
            or circumstances occur that the organizer cannot fulfill his
            contractual obligations against NecessaryDevil or third parties in
            default of assets, and “in addition” the organizer gives no proof of
            sufficient assets within 30 days after request by NecessaryDevil to
            do so.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Cancellation (Account cancellation)
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            If you desire to cancel your services, please email{" "}
            <strong>service@interfaceinfosoft.com</strong> 15 days before expiry
            of the service. There is no cancellation fee. Once your account is
            cancelled, your Content may not be recovered. There will be no
            refund if you cancel the Service later than 15 days before expiry of
            the service, you will not be billed.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Ticket Buyers Terms
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            The price payable for tickets shall be as set on the website.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            If, at any time during the event it is cancelled, postponed,
            suspended or delayed for any reason, NecessaryDevil will not make
            any refunds nor will they be liable for any loss caused by such
            cancellation, postponement, suspension or delay.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            It is your responsibility to ascertain whether an event has been
            cancelled and the date and time of any rearranged event. If an event
            is cancelled or rescheduled the responsibility of its notification
            lies with the Event Organizer only.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Tickets may be restricted to a maximum number per person, per credit
            card and, for some events, a restriction may apply per household. We
            reserve the right to cancel tickets without prior notice purchased
            in excess of this number.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              General Terms
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil would not be held liable for any inappropriateness of
            the advertisement content, invisible/hidden content, error, omission
            or inaccuracy in printed or digital form. NecessaryDevil reserves
            the right to remove and/or reposition the advertising material.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Safe Harbor
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Any statements contained within the Site concerning NecessaryDevil’s
            future prospects are forward-looking statements which involve a
            number of risks, uncertainties and other factors that could cause
            actual results to differ materially from those that may be projected
            by these forward-looking statements. There can be no assurance that
            future results will be achieved, and actual results could differ
            materially from forecasts, estimates and summary information
            contained in the site.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Intellectual Property Rights
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree that NecessaryDevil owns all rights to the code,
            databases, visual-design and layout of the Service. Except for the
            limited licenses expressly granted to you under this Agreement, no
            other rights, licenses, or immunities are granted or will be deemed
            to be granted to you under this Agreement, either expressly, or by
            implication, estoppel or otherwise. You may access the site solely
            as intended through the provided functionality of the Service and as
            permitted under this Agreement and shall at all times abide by the
            terms set forth herein.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • NecessaryDevil claims no intellectual property rights over the
            material you provide to the Service. Your profile and materials
            uploaded remain yours. • You may not use any robot, spider, other
            automated device, or manual process to monitor or copy any Content
            from the Service.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You may not resell, duplicate or reproduce or exploit any part of
            the Service without the written consent permission of
            NecessaryDevil.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You may not duplicate, copy, or reuse any portion of the visual
            design or layout of the Service without the prior written permission
            of NecessaryDevil.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You may not alter, deface, mutilate or otherwise bypass any
            approved software through which the Services are made available.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to bypass, circumvent, damage or otherwise interfere
            with any security or other features of the site designed to control
            the manner in which the Services are used, harvest or mine content
            from the Services, or otherwise access or use the Services in a
            manner inconsistent with individual human usage.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to undertake, cause, permit or authorize the
            translation, reverse engineering, disassembling or hacking of any
            aspect of the Services, including any Service content available on
            or through the Service, or attempt to do any of the foregoing,
            except and solely to the extent permitted by this Agreement, the
            authorized features of the Services, or by law, or otherwise attempt
            to use or access any portion of the Services other than as intended
            by NecessaryDevil.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to harass, abuse, harm or advocate or incite
            harassment, abuse or harm of another person or group, including
            NecessaryDevil’s employees and other users.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to provide any false personal information to
            NecessaryDevil or any other user or create a false identify or
            impersonate another person or entity in any way.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to solicit, or attempt to solicit, personal
            information from other users.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to restrict, discourage or inhibit any person from
            using the Services, disclose personal information about a third
            person on the Services or obtained from the Services without the
            consent of such person, or collect information about users.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to gain unauthorized access to the Services, to
            other users’ accounts, names or personally identifiable information,
            or to other computers or websites connected or linked to the
            Services.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to post, transmit or otherwise make available any
            virus, worm, spyware or any other computer code, file or program
            that may or is intended to disable, overburden, impair, damage or
            hijack the operation of any hardware, software or telecommunications
            equipment, or any other aspect of the Services or communications
            equipment and computers connected to the Services.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to interfere with or disrupt the Services, or
            networks or servers connected to the Services, or violate the
            regulations, policies or procedures of such networks or servers.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to violate any applicable laws and/or regulations or
            this Agreement.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            • You agree not to assist or permit any persons in engaging in any
            of the activities described above.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Information Disclosure
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            To the extent required or permitted by law, NecessaryDevil may also
            collect, use and disclose personal information in connection with
            security-related or law enforcement investigations or in the course
            of cooperating with authorities or complying with legal
            requirements.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Disclaimer of Warranties
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            You understand and agree that the NecessaryDevil services are
            provided on an “AS IS” and “AS AVAILABLE” basis and that to the
            fullest extent permitted by law, NecessaryDevil excludes all
            representations and warranties relating to this website and its
            contents including in relation to any inaccuracies or omissions in
            this website and/or the NecessaryDevil’s literature; and excludes
            all liability for damages arising out of or in connection with your
            use of this. NecessaryDevil does not warrant that its websites will
            operate error-free or free of computer viruses or mal-functioning or
            harmful mechanisms. All the contents of website are only for general
            information or use. Such information does not constitute advice and
            should not be relied upon in making or derived decisions. Any
            specific advice or replies to queries in any part of the website are
            the personal opinion of users and are not subscribed to by
            NecessaryDevil. This website assumes no responsibility for the
            accuracy or existence of any communications between users.
            NecessaryDevil expressly disclaims all warranties of any kind,
            whether express or implied, including, but not limited to the
            implied warranties of merchantability, fitness for a particular
            purpose and non-infringement. This includes, without limitation,
            direct loss, loss of business or profits (whether or not the loss of
            such profits was foreseeable, arose in the normal course of things
            or you have advised NecessaryDevil of the possibility of such
            potential loss), damage caused to your computer, computer software,
            systems and programs and the data thereon or any other direct or
            indirect, consequential and incidental damages.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil makes no warranty that the services will meet your
            requirements, service will be uninterrupted, timely, secure or
            error-free. Certain links on website lead to resources located on
            servers maintained by third parties over whom NecessaryDevil has no
            control or connection, business or otherwise as these sites are
            external to this website you agree and understand that by visiting
            such sites you are beyond this website. NecessaryDevil therefore
            neither endorses nor offers any judgment or warranty and accepts no
            responsibility or liability for the authenticity/availability of any
            of the goods/services/or for any damage, loss or harm, direct or
            consequential or any violation of local or international laws that
            may be incurred by your visit and/or transaction/s on these sites.
            Use caution and common sense when using the Service.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            Any material downloaded or otherwise obtained through the use of
            this website is done at your discretion and risk that you will be
            solely responsible for any damage to your computer system or loss of
            data that results from the download of any such material.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Limitation of Liability
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            You agree that NecessaryDevil shall, in no event, be liable for any
            consequential, incidental, indirect, special, punitive or other loss
            or damage whatsoever or for the loss of business profits, business
            interruptions, computer failure, loss of business information, or
            other loss arising out of or caused by your use of or inability to
            use this website, even if NecessaryDevil has been advised of the
            possibility of such damage. NecessaryDevil will not be responsible
            for any business loss (including loss of profits, revenue,
            contracts, anticipated savings, data, goodwill or wasted
            expenditure) or any other indirect or consequential loss that is not
            reasonably foreseeable to both you and us when you commenced using
            the Website. The Venue, event organizers, events services
            ‘marketplace’ information provided on NecessaryDevil are added by
            members. NecessaryDevil doesn’t verify, claim or guarantee
            authenticity of such information. NecessaryDevil is not liable for
            the acts, errors, omissions, representations, warranties, breaches
            or negligence of any such suppliers or for any personal injuries,
            death, property damage, or other damages or expenses resulting there
            from. NecessaryDevil have no liability and will make no refund in
            the event of any delay, cancellation, overbooking, strike, force
            majeure or other causes beyond their direct control, and they have
            no responsibility for any additional expense, omissions, delays,
            re-routing or acts of any government or authority. NecessaryDevil
            makes no representations or warranties as to the completeness or
            accuracy of Information contained on the website. The service
            provided is of such a nature that service can be interrupted for
            many reasons other than the negligence of the company and that
            damages resulting from any interruption of service are difficult to
            ascertain. Therefore, you agree that NecessaryDevil shall not be
            liable for any damages arising from such causes beyond the direct
            and exclusive control of the NecessaryDevil. You further acknowledge
            that NecessaryDevil’s liability for its own negligence may not in
            any event exceed an amount equivalent to charges payable by you for
            services during the period damages occurred. In no event shall the
            NecessaryDevil be liable for any special or consequential damages,
            loss or injury.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            This paragraph shall survive termination of this agreement.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Indemnity
            </Typography>
          </Box>
          <Typography variant="body2" paragraph className={classes.greyText}>
            You agree to defend, indemnify and hold NecessaryDevil, its parent
            (“Interface Infosoft Solutions.P.Ltd”), its subsidiaries and
            affiliates, and each of their directors, officers, agents,
            contractors, partners and employees, harmless from and against any
            loss, liability, claim, demand, damages, costs and expenses,
            including without limitation reasonable attorney’s fees and costs,
            arising out of or in connection with any User Content, any Third
            Party Applications, Software or Content you post or share on or
            through the website (including through the Share Service), your use
            of this website, your conduct in connection with this website or
            with other users of the website , or any violation of this Agreement
            or of any law or the rights of any third party. NecessaryDevil
            reserves the right, at your expense, to assume the exclusive defense
            and control of any matter for which you are required to indemnify
            NecessaryDevil, including rights to settle, and you agree to
            cooperate with NecessaryDevil’s defense and settlement of these
            claims. You hereby expressly release NecessaryDevil its affiliates,
            their officers, directors, shareholders, employees and agents from
            any cost, damage, liability or other consequence of any of the
            actions/inactions of our partners/sellers and specifically waiver
            any claims or demands that you may have in this behalf under any
            statute, contract or otherwise.
          </Typography>
          <Typography variant="body2" paragraph className={classes.greyText}>
            This paragraph shall survive termination of this agreement.
          </Typography>

          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Force Marjorie
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              We shall not be liable to you for any failure to perform any
              obligation under this Agreement or any other Agreement which is
              due to an event beyond the control of such party including but not
              limited to any act of God, terrorism, war, political insurgence,
              insurrection, riot, civil unrest, act of civil or military
              authority, uprising, earthquake, flood or any other natural or
              manmade eventuality outside of our control, which causes the
              termination of an agreement or contract entered into, nor which
              could have been reasonably foreseen. If we are affected by such
              event, we shall forthwith inform you of the same through our
              website and shall use all reasonable endeavors to comply with the
              terms and conditions of any Agreement contained herein.
            </Typography>
          </Box>
          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Termination
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              You agree that NecessaryDevil may terminate your access to the
              site for reasons including, but not be limited to, breaches or
              violations of the Terms or the NecessaryDevil’s Privacy Policy, a
              request by you to terminate, unexpected technical issues or
              problems, and requests by law enforcement or other government
              agencies.
            </Typography>
          </Box>
          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Settlement & arbitration of disputes
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              The courts in Pune, Maharashtra shall have exclusive jurisdiction
              in respect of any matters arising here-from. Any legal
              issue/dispute arising out of this Agreement, but not exclusive to
              the use of the Services (unless otherwise specifically stated) are
              governed by and in accordance with the laws of India. This
              paragraph shall survive termination of this Agreement.
            </Typography>
            <Typography variant="body2" paragraph className={classes.greyText}>
              By using this website, you agree that any dispute or claim arising
              out of or in connection with this Agreement or the performance,
              breach or termination thereof, shall be finally settled by
              arbitration in Pune in accordance with the provision of the
              Arbitration and Conciliation Act, 1996 in English through the sole
              arbitrator appointed by us. Confidentiality of any and all such
              arbitration and the entire process shall be the responsibility of
              both parties.
            </Typography>
          </Box>
          <Box mt={4} mb={2}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Notice & Take Down Policy
            </Typography>
          </Box>

          <Typography variant="body2" paragraph className={classes.greyText}>
            AS AN INTERMEDIARY, NecessaryDevil/Interface Infosoft Solutions. P.
            Ltd IS NOT LIABLE FOR ANY THIRD-PARTY CONTENT UPLOADED, TRANSMITTED,
            DISPLAYED, PUBLISHED OR SHARED ON ITS PLATFORM. BY USING
            necessarydevil.com, YOU AGREE TO THE CONDITIONS SET OUT IN THIS
            NOTICE AND TAKE DOWN POLICY
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            1. COPYRIGHT INFRINGEMENT NOTIFICATION
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            AS AN INTERMEDIARY, NecessaryDevil/Interface Infosoft Solutions. P.
            Ltd IS NOT LIABLE FOR ANY THIRD-PARTY CONTENT UPLOADED, TRANSMITTED,
            DISPLAYED, PUBLISHED OR SHARED ON ITS PLATFORM. BY USING
            necessarydevil.com, YOU AGREE TO THE CONDITIONS SET OUT IN THIS
            NOTICE AND TAKE DOWN POLICY
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            2. COPYRIGHT INFRINGEMENT NOTIFICATION PROCEDURE
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            NecessaryDevil/ Interface Infosoft Solutions. P. Ltd recommends
            Owners of copyright-protected content to report alleged copyright
            infringement by submitting a written complaint (the “Complaint”)
            either through a web-form (recommended) or through email on
            service@interfaceinfosoft.com The Complaint should include the
            following:
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            i. Contact Information: The Owner will need to provide information
            that will allow NecessaryDevil/ Interface Infosoft Solutions. P. Ltd
            and the uploader(s) of the video(s) that the Owner’s objects to, to
            contact the Owner regarding the Complaint, such as an email address,
            physical address or telephone number
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            ii. Description of Work: The Owner’s must provide in the complaint,
            a complete and accurate description of the copyrighted content that
            the Owner is seeking to protect. This MUST also include the specific
            URL of the video that the Owner believes to be infringing. This is
            necessary in order to aid NecessaryDevil/Interface Infosoft
            Solutions. P. Ltd to locate the allegedly infringing video. General
            information about the video, such as a channel URL or username alone
            is not adequate. The URL should be in the following format:
            https://www.necessarydevil.com/_____________/
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            iii. Necessary Format: The Complaint should include the following
            statements – “I have a good faith belief that the use of the
            material in the manner complained of is not authorized by the
            copyright owner, its agent, or the law.” AND “The information in
            this notification is accurate, and I am the owner, or an agent
            authorized to act on behalf of the owner, of an exclusive right that
            is allegedly infringed.”
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            iv. Signature: The Complaint must include the physical or electronic
            signature/digital signature of the Owner. To satisfy this
            requirement, the Owner may type their full legal name (a first and
            last name, not a company name) as the signature at the bottom of the
            complaint
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            3. NOTIFICATION OF OBJECTIONABLE CONTENT AND TAKE DOWN BY
            NecessaryDevil/ Interface Infosoft Solutions. P. Ltd
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            4. Users may submit a complaint against objectionable content by
            submitting a written complaint (the “Complaint”) either through a
            web-form (recommended) or through email on
            service@interfaceinfosoft.com The Complaint should include the
            following:
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            i. Contact Information: The Complainant will need to provide
            information that will allow to contact the Complainant regarding the
            Complaint, such as an email address, physical address or telephone
            number.
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            ii. Description of Work: The Complainant must provide in the
            complaint, a description of the objectionable content that the
            Complainant is seeking to protest. This MUST also include the
            specific URL of the video that the Complainant believes to be
            objectionable. This is necessary in order to aid NecessaryDevil/
            Interface Infosoft Solutions. P. Ltd to locate the allegedly
            objectionable video. General information about the video, such as a
            channel URL or username alone shall not be adequate. The URL should
            be in the following format:
            http://www.necessarydevil.com/_____________/
          </Typography>

          <Typography variant="body2" className={classes.greyText}>
            iii. If NecessaryDevil/ Interface Infosoft Solutions. P. Ltd
            determines, in its sole discretion and judgment, that the User
            Content violates any of the aforementioned conditions, it shall be
            entitled to immediately take down or otherwise block access to User
            Content
          </Typography>

          <Typography variant="body2" paragraph className={classes.greyText}>
            5. NecessaryDevil/ Interface Infosoft Solutions. P. Ltd IMMUNITY
            FROM LIABILITY
          </Typography>

          <Box mt={4} mb={2}>
            <Typography variant="body2" paragraph className={classes.greyText}>
              NecessaryDevil/ Interface Infosoft Solutions. P. Ltd is an
              intermediary and shall not be liable for any act of copyright
              infringement or any other objectionable User Content, as provided
              under the Copyright Act, 1957, Information Technology Act, 2000
              and Rules thereunder.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <ScrollTop />
    </>
  );
}

const styles = (theme) => ({
  greyText: {
    color: "#616161",
    fontFamily: "Poppins, sans-serif",
  },
});

export default compose(withStyles(styles), withRouter)(TermsOfServices);
